import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import MobileRepairBookingPage from './Mobile-Repair-Booking-Page';
import ModelPage from './pages/ModelPage';
import ServicePage from './pages/ServicePage';
import CartPage from './pages/CartPage';
import AddressPage from './pages/AddressPage';
import PaymentStatusPage from './pages/PaymentStatusPage';
import LoginPage from './pages/LoginPage';
import OrderSummaryPage from './pages/OrderSummaryPage';
import OrdersPage from './pages/OrdersPage';
import { CartProvider } from './context/CartContext';
import CartFooter from './components/CartFooter';
import AboutUsPage from './pages/AboutUsPage';
import FAQPage from './pages/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import RefundsCancellationsPage from './pages/RefundsCancellationsPage';
// import ModelPage (to be created)

const App: React.FC = () => {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<MobileRepairBookingPage />} />
            <Route path="brand/:brandId" element={<ModelPage />} />
            <Route path="services/:modelId" element={<ServicePage />} />
            <Route path="services/:modelId/*" element={<ServicePage />} />
          </Route>
          <Route path="/cart" element={<CartPage />} />
          <Route path="/address" element={<AddressPage />} />
          <Route path="/payment-status/:orderId" element={<PaymentStatusPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/order-summary/:orderId" element={<OrderSummaryPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/refunds-cancellations" element={<RefundsCancellationsPage />} />
        </Routes>
        <CartFooter />
      </Router>
    </CartProvider>
  );
};

export default App; 